import { http } from '@/services'
import { httpWill } from '@/services'

import jwt_decode from 'jwt-decode'
import router from '@/router'
import axios from 'axios'

const actions = {

  // Vertical NavMenu

  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest

  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar

  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },
  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // authentication

  setHttpHeaders ({ getters }) {
    const baseHTTP = {
      baseUrl: getters.endpoints.baseUrl,
      headers: {
        Authorization: `JWT ${getters.tokens.access}`,
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers = baseHTTP.headers
  },
  logout ({ commit }, noReRoute) {
    commit('removeTokens')
    commit('clearInitialise')
    if (!noReRoute) {
      // window.location.href = 'http://127.0.0.1:8000/logged_out'
      router.push('/login').catch(error => { console.log(error) })
    }
  },
  async _setTokens ({ commit, getters, dispatch }, data) {
    commit('loginError', null)
    commit('accessToken', data.access)
    commit('refreshToken', data.refresh)
    dispatch('setHttpHeaders')
    if (!data.noRedirect) {
      router.push('/home').catch(error => { console.log(error) })
    }
    if (!getters.user) dispatch('userFetch')
    return Promise.resolve(true)
  },
  async obtainToken ({ commit, getters, dispatch }, data) {
    const payload = {
      email: data.email,
      password: data.password
    }
    axios.defaults.withCredentials = true

    return axios.post(getters.endpoints.obtainJWT, payload)
    .then((response) => {
      if (data.noRedirect) {
        response.data.noRedirect = true
        dispatch('_setTokens', response.data)
      } else {
        dispatch('_setTokens', response.data)
      }
    })
    .catch((error) => {
      if (error.response.data && error.response.data.dev_code && error.response.data.dev_code === 'change_password_handover' && error.response.data.user_hash) {
        router.push(`/account_handover/${error.response.data.user_hash}`).catch(error => { console.log(error) })
      } else if (error.response.data && error.response.data.dev_code && error.response.data.dev_code === 'user_is_broker') {
        if (process.env.NODE_ENV === 'production') {
          window.location.href = 'https://www.mylastwill.co.uk/broker'
        } else {
          window.location.href = 'http://127.0.0.1:8000/broker'
        }
      } else {
        commit('loginError', error.response.data)
        throw error
      }
    })
  },
  async refreshToken ({ commit, getters, dispatch }) {
    console.log('refresh tokens')
    const decoded = jwt_decode(getters.tokens.refresh)
    const exp = decoded.exp
    const now = Date.now() / 1000

    if (!getters.tokens.refresh || exp - now <= 0) {
      dispatch('logout')
      return
    }

    const payload = {
      refresh: getters.tokens.refresh
    }

    return axios.post(getters.endpoints.refreshJWT, payload)
    .then((response) => {
      commit('accessToken', response.data.access)
      dispatch('setHttpHeaders')
      try {
        dispatch('userFetch')
        console.log('here 125')
        console.log(router)
        router.push('/home').catch(error => { console.log(error) })
      } catch (error) {
        throw error
      }
      return Promise.resolve(true)
    })
    .catch((error) => {
      console.log('error in refreshing call', error)
      return Promise.resolve(false)
    })
  },
  async inspectToken ({ dispatch, getters, commit }) {
    console.log('inspect tokens')
    const token = getters.tokens.access

    if (token) {
      if (http.defaults && http.defaults.headers.Authorization !== `JWT ${token}`) {
        dispatch('setHttpHeaders')
      }

      const decoded = jwt_decode(token)
      const exp = decoded.exp
      const now = Date.now() / 1000

      if (exp - now < 300) { // less than 5 minutes to go 300
        let response = dispatch('refreshToken')
        return response
      } else if (exp - now < 86400) { // 1 day
        // DO NOTHING, DO NOT REFRESH
        if (!getters.user) {
          try {
            dispatch('userFetch')
            // if (router.currentRoute && router.currentRoute.name !== 'Overview') router.push('/home').catch(error => { console.log(error) })
          } catch (error) {
            throw error
          }
        } else {
          if (router.currentRoute && router.currentRoute.name !== 'Overview') router.push('/home').catch(error => { console.log(error) })
        }
      } else {
        dispatch('logout')
      }
    } else {
      dispatch('logout')
    }
    return Promise.resolve(true)
  },

  // app logic

  initialise ({ dispatch, getters }) {
    dispatch('homeDataFetch')
  },
  userFetch ({ commit, dispatch }) {
    http.get('user_current').then((response) => {
      commit('user',
      { authUser: response.data, isAuthenticated: true }
      )
      dispatch('initialise')
    }).catch(
    error => {
      console.log('error here user fetch')
      console.log(error)
    }
    )
  },
  homeDataFetch({ commit}) {
    http.get('homepage_data').then((response) => {
      commit('homeData', response.data)
    }).catch(
    error => {
      console.log(error)
    }
    )

  }






}

export default actions
